/**
 * Datos que recibe `ProgressDialogComponent` por `MAT_DIALOG_DATA`.
 */
export interface ProgressDialogData {
  title: string;
  message: string;
  /**
   * Línea secundaria opcional para bajar la ansiedad en operaciones largas
   * (p. ej. "Puede demorar según el rango de fechas seleccionado").
   */
  hint?: string;
  cancelLabel?: string;
}

/**
 * Resultado con el que cierra el diálogo cuando el usuario pulsa Cancelar. Si
 * la operación termina sola, quien la lanzó cierra el diálogo sin resultado.
 */
export const PROGRESS_DIALOG_CANCEL_RESULT = 'cancel';
